import React, {forwardRef} from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './menu.module.styl';

import type {ComponentPropsWithRef} from 'react';


const classNames = withCssModule(styles);

type RootProps = Omit<ComponentPropsWithRef<'li'>, 'value'>;

export interface MenuItemBaseProps extends RootProps {

    /**
     * Highlighted state of item
     * */
    highlighted?: boolean,

    /**
     * Disabled status of item
     */
    disabled?: boolean,

    /**
     * Selected status of item
     */
    selected?: boolean,
}

/**
 * Base component for menu item.
 */
export const MenuItemBase = forwardRef<HTMLLIElement, MenuItemBaseProps>((props, ref) => {
    const {
        disabled,
        selected,
        children,
        highlighted,
        className,
        ...rootProps
    } = props;
    const itemClasses = classNames('item', className, {
        item_disabled: disabled,
        selected,
        item__highlighted: highlighted,
    });

    return (
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props
        <li
            role="menuitem"
            aria-selected={selected}
            aria-disabled={disabled}
            {...rootProps}
            className={itemClasses}
            ref={ref}>
            {children}
        </li>
    );
});

MenuItemBase.displayName = 'MenuItemBase';
